"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _vuex = require("vuex");
var _application = require("@/services/application.service");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Estrutura',
  components: {
    Page: _Page.default
  },
  data: function data() {
    return {
      expandedLotes: [],
      selectedSetor: null,
      selectedLote: null,
      setorApplications: [],
      loadingApplications: false,
      lotes: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    menuItems: 'menuItemsApplications',
    farm: 'GET_FARM',
    user: 'userAdmin'
  })),
  mounted: function mounted() {
    this.loadLotes();
  },
  methods: {
    loadLotes: function () {
      var _loadLotes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$applicationSer, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return _application.applicationService.fetchLots({
                farmId: this.farm.id
              });
            case 1:
              _yield$applicationSer = _context.v;
              response = _yield$applicationSer.data;
              if (response && response.data && Array.isArray(response.data)) {
                this.lotes = response.data.map(function (lote) {
                  return {
                    id: lote.id,
                    nome: lote.name,
                    tamanho: lote.area,
                    setores: (lote.sectors || []).map(function (setor) {
                      return {
                        id: setor.id,
                        nome: setor.name,
                        tamanho: setor.area,
                        lotId: lote.id
                      };
                    })
                  };
                });
              } else {
                this.lotes = [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadLotes() {
        return _loadLotes.apply(this, arguments);
      }
      return loadLotes;
    }(),
    toggleLote: function toggleLote(loteId) {
      var index = this.expandedLotes.indexOf(loteId);
      if (index > -1) {
        this.expandedLotes.splice(index, 1);
      } else {
        this.expandedLotes.push(loteId);
      }
    },
    openLoteModal: function openLoteModal() {
      var lote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: "\n            <b-modal\n              class=\"modal-new-lote\"\n              :active=\"true\"\n              :width=\"598\"\n              scroll=\"keep\"\n              :can-cancel=\"['escape']\"\n              :on-cancel=\"cancelModal\"\n            >\n              <div class=\"card\">\n                <div class=\"card-content\">\n                  <div class=\"media\">\n                    <div class=\"media-content\">\n                      <button type=\"button\" class=\"btn-x-close\" @click=\"cancelModal\">\n                        <i class=\"icon-ic_close\" />\n                      </button>\n                      <p class=\"title\">\n                        {{ isEdit ? 'Editar lote' : 'Novo lote' }}\n                      </p>\n                    </div>\n                  </div>\n                  <div class=\"content\">\n                    <form>\n                      <b-field label=\"Nome\">\n                        <b-input v-model=\"form.nome\" placeholder=\"Nome do lote\" required></b-input>\n                      </b-field>\n                      <b-field label=\"Tamanho (ha)\">\n                        <b-input v-model=\"form.tamanho\" type=\"number\" step=\"0.1\" placeholder=\"Ex: 25.5\" required></b-input>\n                      </b-field>\n                      <b-field class=\"row-save-form\">\n                        <b-button class=\"btn-save-form\" @click=\"save\">\n                          {{ isEdit ? 'Gravar' : 'Criar' }}\n                        </b-button>\n                      </b-field>\n                    </form>\n                  </div>\n                </div>\n              </div>\n            </b-modal>\n          ",
          data: function data() {
            return {
              isEdit: !!lote,
              form: {
                nome: (lote === null || lote === void 0 ? void 0 : lote.nome) || '',
                tamanho: (lote === null || lote === void 0 ? void 0 : lote.tamanho) || ''
              }
            };
          },
          methods: {
            save: function save() {
              this.cancelModal();
              if (this.isEdit) {
                this.$parent.$parent.updateLote(this.form, lote);
              } else {
                this.$parent.$parent.createLote(this.form);
              }
            },
            cancelModal: function cancelModal() {
              this.$parent.close();
            }
          }
        },
        hasModalCard: false
      });
    },
    openSetorModal: function openSetorModal(loteId) {
      var setor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: "\n            <b-modal\n              class=\"modal-new-setor\"\n              :active=\"true\"\n              :width=\"598\"\n              scroll=\"keep\"\n              :can-cancel=\"['escape']\"\n              :on-cancel=\"cancelModal\"\n            >\n              <div class=\"card\">\n                <div class=\"card-content\">\n                  <div class=\"media\">\n                    <div class=\"media-content\">\n                      <button type=\"button\" class=\"btn-x-close\" @click=\"cancelModal\">\n                        <i class=\"icon-ic_close\" />\n                      </button>\n                      <p class=\"title\">\n                        {{ isEdit ? 'Editar setor' : 'Novo setor' }}\n                      </p>\n                    </div>\n                  </div>\n                  <div class=\"content\">\n                    <form>\n                      <b-field label=\"Nome\">\n                        <b-input v-model=\"form.nome\" placeholder=\"Nome do setor\" required></b-input>\n                      </b-field>\n                      <b-field label=\"Tamanho (ha)\">\n                        <b-input v-model=\"form.tamanho\" type=\"number\" step=\"0.1\" placeholder=\"Ex: 12.3\" required></b-input>\n                      </b-field>\n                      <b-field class=\"row-save-form\">\n                        <b-button class=\"btn-save-form\" @click=\"save\">\n                          {{ isEdit ? 'Gravar' : 'Criar' }}\n                        </b-button>\n                      </b-field>\n                    </form>\n                  </div>\n                </div>\n              </div>\n            </b-modal>\n          ",
          data: function data() {
            return {
              isEdit: !!setor,
              form: {
                nome: (setor === null || setor === void 0 ? void 0 : setor.nome) || '',
                tamanho: (setor === null || setor === void 0 ? void 0 : setor.tamanho) || ''
              }
            };
          },
          methods: {
            save: function save() {
              this.cancelModal();
              if (this.isEdit) {
                this.$parent.$parent.updateSetor(this.form, setor);
              } else {
                this.$parent.$parent.createSetor(this.form, loteId);
              }
            },
            cancelModal: function cancelModal() {
              this.$parent.close();
            }
          }
        },
        hasModalCard: false
      });
    },
    editLote: function editLote(lote) {
      this.openLoteModal(lote);
    },
    editSetor: function editSetor(setor, loteId) {
      this.openSetorModal(loteId, setor);
    },
    deleteLote: function deleteLote(lote) {
      var _this = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir Lote',
        message: "Tem certeza de que deseja <b>excluir</b> o lote \"".concat(lote.nome, "\"? <b>Essa a\xE7\xE3o n\xE3o poder\xE1 ser desfeita.</b>"),
        cancelText: 'Cancelar',
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var _t2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  _context2.p = 0;
                  _context2.n = 1;
                  return _application.applicationService.deleteLot(lote.id, _this.farm.id);
                case 1:
                  _this.$buefy.toast.open({
                    message: "Lote \"".concat(lote.nome, "\" exclu\xEDdo com sucesso!"),
                    type: 'is-success'
                  });
                  _this.loadLotes();
                  _context2.n = 3;
                  break;
                case 2:
                  _context2.p = 2;
                  _t2 = _context2.v;
                  _this.$buefy.toast.open({
                    message: 'Erro ao excluir lote. Tente novamente.',
                    type: 'is-danger'
                  });
                case 3:
                  return _context2.a(2);
              }
            }, _callee2, null, [[0, 2]]);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    createLote: function () {
      var _createLote = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(form) {
        var data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              data = {
                name: form.nome,
                area: parseFloat(form.tamanho),
                farmId: this.farm.id
              };
              _context3.n = 1;
              return _application.applicationService.createLot(data);
            case 1:
              this.$buefy.toast.open({
                message: 'Lote criado com sucesso!',
                type: 'is-success'
              });
              this.loadLotes();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$buefy.toast.open({
                message: 'Erro ao criar lote. Tente novamente.',
                type: 'is-danger'
              });
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function createLote(_x) {
        return _createLote.apply(this, arguments);
      }
      return createLote;
    }(),
    updateLote: function () {
      var _updateLote = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(form, lote) {
        var data, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              data = {
                name: form.nome,
                area: parseFloat(form.tamanho),
                farmId: this.farm.id
              };
              _context4.n = 1;
              return _application.applicationService.updateLot(lote.id, data);
            case 1:
              this.$buefy.toast.open({
                message: 'Lote editado com sucesso!',
                type: 'is-success'
              });
              this.loadLotes();
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              this.$buefy.toast.open({
                message: 'Erro ao editar lote. Tente novamente.',
                type: 'is-danger'
              });
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateLote(_x2, _x3) {
        return _updateLote.apply(this, arguments);
      }
      return updateLote;
    }(),
    createSetor: function () {
      var _createSetor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(form, loteId) {
        var data, _error$response, _error$response$data, _error$data, message, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              data = {
                name: form.nome,
                area: parseFloat(form.tamanho),
                farmId: this.farm.id,
                lotId: loteId
              };
              _context5.n = 1;
              return _application.applicationService.createSector(data);
            case 1:
              this.$buefy.toast.open({
                message: 'Setor criado com sucesso!',
                type: 'is-success'
              });
              this.loadLotes();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              message = _t5.message || ((_error$response = _t5.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || ((_error$data = _t5.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || '';
              if (_t5.status === 400 && message.includes('Sector creation failed')) {
                this.$buefy.toast.open({
                  message: 'A área total dos setores não pode ultrapassar a área do lote',
                  type: 'is-danger'
                });
              } else {
                this.$buefy.toast.open({
                  message: 'Erro ao criar setor. Tente novamente.',
                  type: 'is-danger'
                });
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function createSetor(_x4, _x5) {
        return _createSetor.apply(this, arguments);
      }
      return createSetor;
    }(),
    updateSetor: function () {
      var _updateSetor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(form, setor) {
        var data, _error$response2, _error$response2$data, _error$data2, message, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              data = {
                name: form.nome,
                area: parseFloat(form.tamanho),
                farmId: this.farm.id,
                lotId: setor.lotId
              };
              _context6.n = 1;
              return _application.applicationService.updateSector(setor.id, data);
            case 1:
              this.$buefy.toast.open({
                message: 'Setor editado com sucesso!',
                type: 'is-success'
              });
              this.loadLotes();
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              message = _t6.message || ((_error$response2 = _t6.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || ((_error$data2 = _t6.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.message) || '';
              if (_t6.status === 400 && message.includes('Sector update failed')) {
                this.$buefy.toast.open({
                  message: 'A área total dos setores não pode ultrapassar a área do lote',
                  type: 'is-danger'
                });
              } else {
                this.$buefy.toast.open({
                  message: 'Erro ao editar setor. Tente novamente.',
                  type: 'is-danger'
                });
              }
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function updateSetor(_x6, _x7) {
        return _updateSetor.apply(this, arguments);
      }
      return updateSetor;
    }(),
    deleteSetor: function deleteSetor(setor, loteId) {
      var _this2 = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir Setor',
        message: "Tem certeza de que deseja <b>excluir</b> o setor \"".concat(setor.nome, "\"? <b>Essa a\xE7\xE3o n\xE3o poder\xE1 ser desfeita.</b>"),
        cancelText: 'Cancelar',
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function () {
          var _onConfirm2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
            var _t7;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  _context7.p = 0;
                  _context7.n = 1;
                  return _application.applicationService.deleteSector(setor.id, _this2.farm.id);
                case 1:
                  _this2.$buefy.toast.open({
                    message: "Setor \"".concat(setor.nome, "\" exclu\xEDdo com sucesso!"),
                    type: 'is-success'
                  });
                  _this2.loadLotes();
                  _context7.n = 3;
                  break;
                case 2:
                  _context7.p = 2;
                  _t7 = _context7.v;
                  _this2.$buefy.toast.open({
                    message: 'Erro ao excluir setor. Tente novamente.',
                    type: 'is-danger'
                  });
                case 3:
                  return _context7.a(2);
              }
            }, _callee7, null, [[0, 2]]);
          }));
          function onConfirm() {
            return _onConfirm2.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    selectSetor: function selectSetor(setor, lote) {
      this.selectedSetor = setor;
      this.selectedLote = lote;
      this.loadLoteApplications(lote.id, setor.id);
    },
    loadLoteApplications: function () {
      var _loadLoteApplications = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(loteId, setorId) {
        var _this3 = this;
        var _yield$applicationSer2, response, setorApplications, _t8;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.loadingApplications = true;
              _context8.p = 1;
              _context8.n = 2;
              return _application.applicationService.fetchApplicationsByLot(this.farm.id, loteId);
            case 2:
              _yield$applicationSer2 = _context8.v;
              response = _yield$applicationSer2.data;
              if (response && Array.isArray(response)) {
                // Filtrar aplicações do setor selecionado
                setorApplications = response.filter(function (app) {
                  return app.sectorId === setorId;
                });
                this.setorApplications = setorApplications.map(function (app) {
                  var _app$prescription, _app$prescription2, _app$prescription2$pr;
                  return {
                    id: app.id,
                    status: app.status,
                    dataAplicacao: app.applicationDate,
                    prescricao: ((_app$prescription = app.prescription) === null || _app$prescription === void 0 ? void 0 : _app$prescription.name) || '--',
                    produtos: ((_app$prescription2 = app.prescription) === null || _app$prescription2 === void 0 ? void 0 : (_app$prescription2$pr = _app$prescription2.productsDosage) === null || _app$prescription2$pr === void 0 ? void 0 : _app$prescription2$pr.map(function (p) {
                      return p.productName;
                    })) || [],
                    tempoTrabalho: app.totalDuration ? _this3.formatDuration(app.totalDuration) : '--',
                    periodoAplicacao: _this3.formatPeriodoAplicacao(app.returnDays),
                    aplicador: app.user ? "".concat(app.user.firstName, " ").concat(app.user.lastName) : '--'
                  };
                });
              } else {
                this.setorApplications = [];
              }
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t8 = _context8.v;
              this.setorApplications = [];
            case 4:
              _context8.p = 4;
              this.loadingApplications = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function loadLoteApplications(_x8, _x9) {
        return _loadLoteApplications.apply(this, arguments);
      }
      return loadLoteApplications;
    }(),
    getStatusType: function getStatusType(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'is-warning';
        }
      }
      var types = {
        'PENDING': 'is-light',
        'IN_PROGRESS': 'is-info',
        'PAUSED': 'is-danger',
        'COMPLETED': 'is-success',
        'FINISHED': 'is-success'
      };
      return types[status] || 'is-light';
    },
    getStatusLabel: function getStatusLabel(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'ATRASADO';
        }
      }
      var labels = {
        'PENDING': 'PENDENTE',
        'IN_PROGRESS': 'EM ANDAMENTO',
        'PAUSED': 'PAUSADO',
        'COMPLETED': 'Concluído',
        'FINISHED': 'FINALIZADO'
      };
      return labels[status] || status;
    },
    formatDate: function formatDate(date) {
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    },
    formatDuration: function formatDuration(seconds) {
      if (!seconds || seconds === 0) return '--';
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      return "".concat(hours, "h:").concat(minutes.toString().padStart(2, '0'), "min");
    },
    formatPeriodoAplicacao: function formatPeriodoAplicacao(returnDays) {
      if (returnDays === null || returnDays === undefined) return '--';
      return returnDays > 0 ? 'Recorrente' : 'Único';
    }
  }
};